module.exports = __webpack_public_path__ + "public/Icons/deleteAudio.svg?78bbdac5";